/* ss-lightbox.js — tocchi il video e si apre grande, con audio e comandi */
(function () {
  var box = null, current = null, lastFocus = null;

  function build() {
    box = document.createElement('div');
    box.className = 'ss ss-lb';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.hidden = true;
    box.innerHTML =
      '<div class="ss-lb__scrim" data-lb-close></div>' +
      '<div class="ss-lb__stage">' +
        '<button class="ss-lb__x" type="button" aria-label="Chiudi" data-lb-close>&times;</button>' +
        '<video class="ss-lb__v" controls playsinline preload="metadata"></video>' +
        '<a class="ss-lb__cta" href="#"></a>' +
      '</div>';
    document.body.appendChild(box);
    [].forEach.call(box.querySelectorAll('[data-lb-close]'), function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !box.hidden) close();
    });
  }

  function open(src, poster, href, label) {
    if (!box) build();
    lastFocus = document.activeElement;
    var v = box.querySelector('.ss-lb__v');
    var a = box.querySelector('.ss-lb__cta');
    v.src = src; if (poster) v.poster = poster;
    if (href) { a.href = href; a.textContent = label || 'Vedi il tessuto'; a.hidden = false; }
    else { a.hidden = true; }
    box.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    v.currentTime = 0;
    var p = v.play(); if (p && p.catch) p.catch(function () {});
    box.querySelector('.ss-lb__x').focus();
    current = v;
  }

  function close() {
    if (!box) return;
    if (current) { current.pause(); current.removeAttribute('src'); current.load(); }
    box.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-ss-play]') : null;
    if (!t) return;
    e.preventDefault();
    open(t.getAttribute('data-src'), t.getAttribute('data-poster'),
         t.getAttribute('data-href'), t.getAttribute('data-label'));
  });
})();

/* la tastiera apre il video come il dito */
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter' && e.key !== ' ') return;
  var t = e.target.closest ? e.target.closest('[data-ss-play]') : null;
  if (!t) return;
  e.preventDefault();
  t.click();
});
